/**
 * FND-01: resolves a user-supplied post-login target to a same-origin in-app path.
 * Anything else (other origins, backslashes, control chars, whitespace, /auth loops) -> fallback.
 */
export function safeRedirect(from: unknown, fallback = '/dashboard'): string {
  if (typeof from !== 'string' || from.length === 0) return fallback;
  if (!from.startsWith('/') || from.startsWith('//')) return fallback;
  // eslint-disable-next-line no-control-regex
  if (/[\\\u0000- \u007f-\u009f]/.test(from)) return fallback;
  try {
    const base = window.location.origin;
    const url = new URL(from, base);
    if (url.origin !== base) return fallback;
    // Decoded path must not smuggle a host-relative form either (e.g. /%5Cevil.com, /%09/evil.com).
    let decoded: string;
    try {
      decoded = decodeURIComponent(url.pathname);
    } catch {
      return fallback;
    }
    // eslint-disable-next-line no-control-regex
    if (/[\\\u0000- \u007f-\u009f]/.test(decoded) || decoded.startsWith('//')) return fallback;
    const target = url.pathname + url.search + url.hash;
    if (target === '/auth' || target.startsWith('/auth/') || target.startsWith('/auth?') || target.startsWith('/auth#')) {
      return fallback;
    }
    return target;
  } catch {
    return fallback;
  }
}
